export default __webpack_public_path__ + "static/media/cl12.93ab882a.webp";